import { embla } from "javascripts/webpage/embla";
import { micromodal } from "javascripts/micromodal";
import { backfaceFixed } from "javascripts/backface-fixed";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelectorAll("#js-aggregated_hotels-show", "#js-hotels")) {
    return;
  }
  // 写真 / コメント / 口コミ
  embla("js-embla-photos", { arrows: false });

  // 写真一覧のナビゲーションにClassを付与
  const photosLinks = document.querySelectorAll(".js-photos-link");
  if (photosLinks) {
    photosLinks.forEach((photoLink) => {
      photoLink.addEventListener("click", function () {
        photosLinks.forEach((link) => link.classList.remove("is-active"));
        this.classList.add("is-active");
      });
    });
  }

  // ページ内を遷移後にbackfaceFixedの`top`の位置を計算
  const interval = document.querySelector("[data-interval]");
  if (interval) {
    interval.addEventListener("click", () => {
      backfaceFixed(false);
      const adjustedPosition = setInterval(() => {
        backfaceFixed(true);
        clearInterval(adjustedPosition);
      }, 800);
    });
  }

  // 別ページから遷移後の位置を調整
  let location = window.location.hash;
  const locationMatch = location.substring(1);
  if (locationMatch) {
    const navi = document.querySelector(".js-nav");
    const naviHeight = navi ? navi.clientHeight : "";
    const adjustedPosition = setInterval(() => {
      let target = document.getElementById(locationMatch);
      if (target) {
        // NOTE: 特定の過ごし方に遷移する場合も`target-section-model-case`の位置に遷移させる
        const modelCase = location.match(/^#target-model-case-tab-\d+$/)?.input;
        if (modelCase) {
          target = document.getElementById("target-section-model-case");
        }
        const position = window.pageYOffset + target.getBoundingClientRect().top - naviHeight;
        window.scrollTo({
          top: position,
          behavior: "smooth",
        });
        location = history.replaceState(null, null, " ");
      }
      clearInterval(adjustedPosition);
    });
  }

  // floorguide：写真に遷移した時にModalを開く
  if (location === "#target-section-photo") {
    const adjustedPosition = setInterval(() => {
      micromodal("target-photos-category");
      clearInterval(adjustedPosition);
    });
  }

  // floorguide：コース
  embla("js-embla-course-photos", { indexes: true, thumbnails: true });

  // floorguide：ホテルの1コマ
  embla("js-embla-onesence-photos", { indexes: true });

  // 施設詳細のもっと見る
  const FacilityContents = document.querySelector(".js-facility-guide-details-contents");
  if (FacilityContents) {
    const facilityPlanShowmore = document.querySelectorAll(".js-facility-plans-button");
    const facilityDetailsShowmore = document.querySelectorAll(".js-facility-guide-details-button");
    const getNavHeight = document.querySelector(".js-facility-guide-details-nav-height").clientHeight;
    const getContentsHeight = document.querySelector(".js-facility-guide-details-height").clientHeight;
    // 施設詳細のもっと見る、ナビゲーションリンクをクリックしたら全体を表示
    FacilityContents.style.height = `calc(${getContentsHeight}px + ${getNavHeight}px - 24vh)`;
    if (facilityDetailsShowmore.length > 0) {
      facilityDetailsShowmore.forEach((button) => {
        button.addEventListener("click", () => {
          FacilityContents.style.height = "auto";
          document.querySelectorAll(".js-facility-guide-details-contents").forEach((content) => {
            const contentsButton = content.querySelector(".js-facility-guide-details-button");
            content.classList.remove("p-hotels-show-facility-guide-details--hide");
            contentsButton.style.display = "none";
          });
        });
      });
    }

    // 施設詳細の各プランをもっと見るで表示
    if (facilityPlanShowmore.length > 0) {
      facilityPlanShowmore.forEach((button) => {
        button.addEventListener("click", () => {
          button.style.display = "none";
          button.closest(".js-facility-plans-contens").classList.remove("p-hotels-show-facility-guide-plans--hide");
        });
      });
    }
  }

  // 過ごし方をもっと見るで表示
  const modelcaseShowmore = document.querySelectorAll(".js-model-case-button");
  if (modelcaseShowmore.length > 0) {
    const ClassModelCase = ".js-model-case-contens";
    const modelCaseContents = document.querySelector(ClassModelCase);
    const getContentsHeight = modelCaseContents.clientHeight;
    const getNav = document.querySelector(".js-model-case-nav-height");
    modelcaseShowmore.forEach((button) => {
      // 過ごし方のコンテンツの1/2を表示
      if (getNav) {
        const getNavHeight = getNav.clientHeight;
        modelCaseContents.style.height = `calc((${getContentsHeight}px - (${getNavHeight}px * 2)) / 2)`;
      } else {
        modelCaseContents.style.height = `calc((${getContentsHeight}px) / 2)`;
      }
      button.addEventListener("click", () => {
        button.style.display = "none";
        button.closest(ClassModelCase).classList.remove("p-hotels-show-model-case--hide");
        modelCaseContents.style.height = "auto";
      });
    });
  }
});
